export default function getUpdatedCandidate(state) {
    return state.updatedCandidate;
}